import { createGlobalStyle, css } from 'styled-components';

import { Theme } from '../theme';

const GlobalStyle = createGlobalStyle`
  ${({ theme }: { theme: Theme; }) => css`
    html {
      font-size: ${theme.fontSizes.root};
    }

    body {
      margin: 0;
      background: ${theme.getColor(theme.bodyBackground)};
      touch-action: manipulation;
    }

    body, input, textarea, select, button {
      font-family: ${theme.fontFamilies.body};
      font-size: ${theme.fontSizes.body}rem;
      line-height: 1.5;
      color: ${theme.colors.body};
    }

    @media (max-width: ${theme.breakpoints.md}px) {
      // On mobile, increase the font size of inputs to 16px
      // when focused to prevent the browser from zooming in.
      input:focus, textarea:focus, select:focus {
        font-size: ${theme.fontSizes.root};
      }
    }

    input:focus-visible, textarea:focus-visible, select:focus-visible, button:focus-visible, a:focus-visible {
      outline-width: 2px;
      outline-color: ${theme.getSufficientContrast(theme.getColor('secondary.500'))};
      outline-style: solid;
      outline-offset: -1px;
    }

    * {
      box-sizing: border-box;
    }

    a {
      text-decoration: none;
      color: ${theme.colors.link};
    }

    p {
      margin: 0 0 1em 0;
    }

    ul {
      margin: 0;
      padding: 0;

      li {
        margin-left: 1.5em;
        padding: 0;
      }
    }

    h1, h2, h3 {
      letter-spacing: -0.01em;
    }

    h1, h2, h3, h4, h5, h6 {
      font-family: ${theme.fontFamilies.headings};
      margin: 0;
      padding: 0;
    }

    h1 {
      font-size: ${theme.fontSizes.h1}rem;
    }

    h2 {
      font-size: ${theme.fontSizes.h2}rem;
    }

    h3 {
      font-size: ${theme.fontSizes.h3}rem;
    }

    h4 {
      font-size: ${theme.fontSizes.h4}rem;
    }

    h5 {
      font-size: ${theme.fontSizes.h5}rem;
    }

    table {
      border-collapse: collapse;
      border-spacing: 0;
    }

    img {
      max-width: 100%;
    }

    hr {
      margin: 1em 0;
      border: solid rgba(0, 0, 0, .1);
      border-width: 1px 0 0 0;
      padding: 0;
    }
  `}
`;

export default GlobalStyle;
